import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment';
import { Col, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { Field, Form, formValueSelector, propTypes, reduxForm, change } from 'redux-form';
import { load as loadEmployeesAction } from '../../../../reducers/employees/employees.actions';
import { notAdmins } from '../../../../reducers/employees/employees.reducer';
import { load as loadLaborClassesAction } from '../../../../reducers/laborClasses/laborClasses.actions';
import { laborClasses as getLaborClasses } from '../../../../reducers/laborClasses/laborClasses.reducer';
import {
  remove as removeAction,
  save as saveAction,
} from '../../../../reducers/workOrder/employeeTimesheets/employeeTimesheets.actions';
import SelectFormGroup from '../../../Forms/SelectFormGroup/SelectFormGroup';
import TimeFormGroup from '../../../Forms/TimeFormGroup/TimeFormGroup';
import TTFormGroup from '../../../Forms/TTFormGroup/TTFormGroup';
import SpinnerButton from '../../../SpinnerButton/SpinnerButton';
import './EmployeeTimesheetForm.css';


// eslint-disable-next-line object-curly-newline
export class EmployeeTimesheetForm extends React.Component {
  componentDidMount() {
    this.props.loadEmployees();
    this.props.loadLaborClasses();
  }

  render() {
    const {
      employees,
      laborClasses,
      remove,
      employee: {
        id,
        employee_id,
        removing,
        checkin,
        checkout,
        hours,
      },
      handleSubmit,
      save,
      disabled,
      usedEmployees,
      currentEmployeeId,
      form,
    } = this.props;
    const currentEmployee = employees.filter(a => a.id === parseInt(currentEmployeeId, 10))[0];
    const isOther = currentEmployee && currentEmployee.name === 'Other';
    // eslint-disable-next-line camelcase
    const remainingEmployees = employees.filter(a => !usedEmployees.includes(a.id.toString()) || a.id.toString() === employee_id);
    const onFieldChange = () => setTimeout(handleSubmit(params => save(params)));

    const checkoutMoment = moment(checkout, 'H:mma');
    const checkinMoment = moment(checkin, 'H:mma');
    if (hours === '' && checkinMoment.isValid() && checkoutMoment.isValid()) {
      this.props.dispatch(change(form, 'hours', Number(checkoutMoment.diff(checkinMoment, 'minutes') / 60).toFixed(2)));
      onFieldChange();
    }

    return (
      <Form
        onSubmit={() => {
        }}
        onChange={() => setTimeout(handleSubmit(params => save(params)))}
      >
        <Row>
          <Col sm={6} >
            <Field
              component={SelectFormGroup}
              name="employee_id"
              label="Employee"
              options={remainingEmployees}
              required
              disabled={disabled}
            />
          </Col>
          <Col sm={3} >
            <Field
              component={SelectFormGroup}
              name="labor_class_id"
              label="Class"
              options={laborClasses}
              required
              disabled={disabled}
            />
          </Col>
          <Col sm={3} >
            <Field
              component={SelectFormGroup}
              showBlank={false}
              name="per_diem"
              label="Per Diem"
              options={[{ id: false, name: 'No' }, { id: true, name: 'Yes' }]}
            />
          </Col>
        </Row>
        { isOther &&
        <Row>
          <Col sm={12} >
            <Field
              component={TTFormGroup}
              name="other_name"
              label="Other Name"
              type="text"
              required
              disabled={disabled}
            />
          </Col>
        </Row>
        }
        <Row>
          <Col sm={3} >
            <Field
              component={TimeFormGroup}
              name="checkin"
              label="Check In"
              disabled={disabled}
              onFieldChange={onFieldChange}
            />
          </Col>
          <Col sm={3} >
            <Field
              component={TimeFormGroup}
              name="checkout"
              label="Check Out"
              disabled={disabled}
              onFieldChange={onFieldChange}
            />
          </Col>
          <Col sm={3} >
            <Field
              component={TTFormGroup}
              name="hours"
              label="Hours"
              type="text"
              required
              disabled={disabled}
            />
          </Col>
          <Col sm={2} >
            <Field
              component={TTFormGroup}
              name="truck_rig"
              label="Truck/Rig Pay"
              type="text"
              disabled={disabled}
            />
          </Col>
          <Col sm={1} >
            <SpinnerButton
              className="removeButton"
              bsStyle="danger"
              onClick={() => remove(id)}
              isLoading={removing}
              disabled={disabled}
            >
              -
            </SpinnerButton>
          </Col>
        </Row>
      </Form>);
  }
}

EmployeeTimesheetForm.propTypes = {
  ...propTypes,
  employees: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  laborClasses: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  remove: PropTypes.func.isRequired,
};

export const mapStateToProps = (state, ownProps) => ({
  initialValues: ownProps.employee,
  form: `employee${ownProps.employee.id}`,
  employees: notAdmins(state),
  laborClasses: getLaborClasses(state),
  currentEmployeeId: formValueSelector(`employee${ownProps.employee.id}`)(state, 'employee_id'),
});

export const mapDispatchToProps = dispatch => ({
  remove: id => dispatch(removeAction(id)),
  loadEmployees: () => dispatch(loadEmployeesAction()),
  loadLaborClasses: () => dispatch(loadLaborClassesAction()),
  save: values => dispatch(saveAction(values)),
});

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
  enableReinitialize: true,
})(EmployeeTimesheetForm));



// WEBPACK FOOTER //
// ./src/components/WorkOrder/Employees/EmployeeTimesheetForm/EmployeeTimesheetForm.jsx